module.exports = __webpack_public_path__ + "img/sabaideeV3.109749ba.jpg";